module.exports = __webpack_public_path__ + "static/media/novena.be69a841.jpg";